module.exports = __webpack_public_path__ + "img/17.4efa0efb.jpg";